export const PAST_EVENTS_MONTHS = 6;

export function toUtcIsoDate(date = new Date()): string {
  return date.toISOString().slice(0, 10);
}

export function addUtcMonths(isoDate: string, monthsToAdd: number): string {
  const [year, month, day] = isoDate.split('-').map(Number);
  const next = new Date(Date.UTC(year, (month || 1) - 1 + monthsToAdd, day || 1));
  return next.toISOString().slice(0, 10);
}

export function getPastEventsCutoffIsoDate(
  todayIsoDate: string,
  months = PAST_EVENTS_MONTHS
): string {
  return addUtcMonths(todayIsoDate, -months);
}

export function getEventEffectiveEndDate(event: {
  start_date?: string | null;
  end_date?: string | null;
}): string {
  const end = String(event.end_date ?? '').slice(0, 10);
  const start = String(event.start_date ?? '').slice(0, 10);
  return end || start;
}

export function isEventPastToday(
  event: { start_date?: string | null; end_date?: string | null },
  todayIsoDate: string
): boolean {
  const effectiveEndDate = getEventEffectiveEndDate(event);
  return Boolean(effectiveEndDate) && effectiveEndDate < todayIsoDate;
}

export function isEventInPastWindow(
  event: { start_date?: string | null; end_date?: string | null },
  todayIsoDate: string,
  months = PAST_EVENTS_MONTHS
): boolean {
  if (!isEventPastToday(event, todayIsoDate)) return false;
  const cutoff = getPastEventsCutoffIsoDate(todayIsoDate, months);
  const start = String(event.start_date ?? '').slice(0, 10);
  const end = getEventEffectiveEndDate(event);
  return start >= cutoff || end >= cutoff;
}

export function compareEventsByStartDateAsc(
  a: { start_date?: string | null; end_date?: string | null },
  b: { start_date?: string | null; end_date?: string | null }
): number {
  const aStart = String(a.start_date ?? '').slice(0, 10);
  const bStart = String(b.start_date ?? '').slice(0, 10);
  if (aStart !== bStart) return aStart.localeCompare(bStart);
  return getEventEffectiveEndDate(a).localeCompare(getEventEffectiveEndDate(b));
}

export function compareEventsByStartDateDesc(
  a: { start_date?: string | null; end_date?: string | null },
  b: { start_date?: string | null; end_date?: string | null }
): number {
  return compareEventsByStartDateAsc(b, a);
}

export type EventsDateFilter =
  | { kind: 'none' }
  | { kind: 'gteStart'; value: string }
  | { kind: 'onOrAfter'; value: string };

export function getEventsDateFilter(options: {
  upcomingOnly: boolean;
  includePastMonths: number;
  todayIsoDate: string;
}): EventsDateFilter {
  if (!options.upcomingOnly) return { kind: 'none' };
  if (options.includePastMonths > 0) {
    return {
      kind: 'onOrAfter',
      value: getPastEventsCutoffIsoDate(options.todayIsoDate, options.includePastMonths),
    };
  }
  return { kind: 'gteStart', value: options.todayIsoDate };
}
